import PropTypes from 'prop-types';
import React from 'react';
import LoyaltyCouponNewUser from './loyalty-coupon-newuser';
import LoyaltyCouponMember from './loyalty-coupon-member';
import LoyaltyCouponSignUp from './loyalty-coupon-signup';
import LoyaltyCouponSuccess from './loyalty-coupon-success';

const LoyaltyCouponBody = ({
  isCouponApplied,
  isLoggedIn,
  isLoyaltyMember,
  isExplicitOrAutoLoggedIn,
  disclaimers,
  messaging,
  error,
  setError,
  claimLoyaltyCouponByEmail,
  claimLoyaltyCoupon,
  onExitModal,
  isLoading,
  profile,
  onSimpleExitModal,
}) => {
  if (!isCouponApplied) {
    if (!isLoggedIn) {
      return (
        <LoyaltyCouponNewUser
          setError={setError}
          claimLoyaltyCouponByEmail={claimLoyaltyCouponByEmail}
          error={error}
          disclaimers={disclaimers}
          onExitModal={onExitModal}
        />
      );
    }
    if (isExplicitOrAutoLoggedIn && isLoyaltyMember) {
      return (
        <LoyaltyCouponMember claimLoyaltyCoupon={claimLoyaltyCoupon} isLoading={isLoading} error={error} loyaltyCta={messaging} disclaimer={disclaimers.member} />
      );
    } else {
      return (
        <LoyaltyCouponSignUp
          claimLoyaltyCoupon={claimLoyaltyCoupon}
          disclaimers={disclaimers}
          isLoading={isLoading}
          error={error}
          profile={profile}
        />
      );
    }
  }

  return (
    <LoyaltyCouponSuccess
      loyaltyCta={messaging}
      successDisclaimer={disclaimers.success}
      handleButtonsClick={onSimpleExitModal}
    />
  );
};

LoyaltyCouponBody.propTypes = {
  isCouponApplied: PropTypes.bool,
  isLoggedIn: PropTypes.bool.isRequired,
  isLoyaltyMember: PropTypes.bool.isRequired,
  isExplicitOrAutoLoggedIn: PropTypes.bool.isRequired,
  claimLoyaltyCoupon: PropTypes.func.isRequired,
  disclaimers: PropTypes.shape({}).isRequired,
  messaging: PropTypes.shape({}).isRequired,
  onExitModal: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.object.isRequired,
  profile: PropTypes.shape({
    imagePath: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    login: PropTypes.string.isRequired,
  }).isRequired,
  onSimpleExitModal: PropTypes.func.isRequired,
};

LoyaltyCouponBody.defaultProps = {
  isCouponApplied: false,
};

export default LoyaltyCouponBody;
